import { Loader2 } from "lucide-react";

const variants = {
  primary:
    "bg-collect text-white hover:bg-collect-light shadow-md shadow-collect/20 hover:shadow-collect/30",
  accent:
    "bg-accent text-primary hover:bg-accent-light shadow-md shadow-accent/25 hover:shadow-accent/40",
  outline:
    "border border-primary/20 text-primary bg-transparent hover:bg-primary/5 hover:border-primary/35",
  ghost: "text-primary/70 hover:text-primary hover:bg-primary/5",
};

const sizes = {
  sm: "px-4 py-2 text-sm",
  md: "px-6 py-2.5 text-sm",
  lg: "px-8 py-3 text-sm uppercase tracking-[0.12em]",
};

export default function Button({
  children,
  variant = "primary",
  size = "md",
  loading = false,
  disabled = false,
  className = "",
  type = "button",
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={`
        inline-flex items-center justify-center gap-2 whitespace-nowrap font-bold
        transition-all duration-200 ease-out
        focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2
        disabled:opacity-60 disabled:cursor-not-allowed disabled:shadow-none
        ${variants[variant]} ${sizes[size]} ${className}
      `}
      {...props}
    >
      {loading && <Loader2 className="h-4 w-4 animate-spin" />}
      {children}
    </button>
  );
}
